export const ActionTypes = {
    GET_DASHBOARD_COUNT_LIST: "GET_DASHBOARD_COUNT_LIST"
};

export const getDashboardCount = (dashboard) => {
    return {
       type: ActionTypes.GET_DASHBOARD_COUNT_LIST,
       payload: dashboard,
    }
};